import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { GaEventService } from '@analytics/services/ga.event.service';
import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Description, fadeInOut, Service } from '@dgx-pr-spa/shared/util';
import { BuildConfigService } from '@dgx-pr-spa/ui-components';
import { ProductDetailsService } from '@product-details/services/product-details.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-add-extras-container',
  templateUrl: './add-extras-container.component.html',
  styleUrls: ['./add-extras-container.component.scss'],
  animations: [fadeInOut],
})
export class AddExtrasContainerComponent implements OnChanges {
  constructor(
    public readonly viewOffersService: ViewOffersService,
    public readonly productDetailsService: ProductDetailsService,
    public readonly additionalServicesService: AdditionalServicesService,
    public readonly buildConfigService: BuildConfigService,
    public gaEventService: GaEventService,
    private location: Location
  ) {}

  Description = Description;
  /**
   * Receives selected offer
   */
  @Input() services = [] as Service[];

  /**
   * Receives installation service
   */
  @Input() installation: Service = null;

  /**
   * Receives disposal service
   */
  @Input() disposal: Service = null;

  /**
   * Receives delivery service
   */
  @Input() delivery: Service = null;

  /**
   * Receives available delivery dates
   */
  @Input() deliveryDates = [];

  /**
   * Receives boolean installation selected state
   */
  @Input() isInstallationSelected = false;

  /**
   * Receives boolean disposal selected state
   */
  @Input() isDisposalSelected = false;

  @Output() continue: EventEmitter<boolean> = new EventEmitter();

  /**
   * External links
   */
  links = this.buildConfigService.config.header.links;

  /**
   * Observable boolean if delivery dates are unavailable
   */
  deliveryDatesError$ = this.productDetailsService.deliveryDatesError$;

  isMieleSupplier$ = this.productDetailsService.selected$.pipe(
    map((selected) => {
      if (!selected) return false;
      return (
        `${selected.supplier_id}` === '6678' ||
        selected.supplier_name === 'Miele'
      );
    })
  );
  /**
   * Filters the selected service from offer service array
   */
  filterService(value: Description) {
    return this.services.filter(({ description }) => description === value)[0];
  }

  /**
   * Click handler for selecting an extra
   */
  onSelect(checked: boolean, description: Description) {
    if (checked) {
      this.additionalServicesService.addExtra(this.filterService(description));
      this.gaEventService.AdditionalServicesExtraSelect({
        payload: description,
      });
    } else {
      this.additionalServicesService.removeExtra(
        this.filterService(description)
      );
    }
  }

  /**
   * Changes to handle new selection
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.services && this.services) {
      this.services.map((service) => {
        if (service.description === Description.Delivery) {
          this.additionalServicesService.removeExtra(service); // prevent adding multiple times
          this.additionalServicesService.addExtra(service);
        }
      });
    }
  }
  /**
   * Navigate to route on click
   */
  onBackLinkClick() {
    this.location.back();
  }

  /**
   * Navigate to contact us on click
   */
  onClick() {
    window.open(this.links.contact_us);
  }
}
